<template>
  <div class="row" style="margin-bottom: 10px; margin-top: 20px">
    <div class="col-md-12 text-center">
      <p
        class="h6 text-secondary"
        v-if="
          retornaSite() == 'Weddbets' &&
          $siteAdmin == false &&
          propSite !== 'Extra'
        "
        style="margin-bottom: 30px"
      >
        Dark Mode? Selecione em
        <a
          href="/meus-dados"
          style="
            background: none !important;
            border: none;
            color: #069;
            text-decoration: underline;
            cursor: pointer;
          "
          >meus dados</a
        >
      </p>

      <div
        class="h6"
        v-if="
          retornaSite() == 'Weddbets' &&
          $siteAdmin == false &&
          propSite === 'Extra'
        "
        style="margin-bottom: 30px"
      >
        <div class="d-flex justify-content-center">
          <h3 class="font-weight-bold" v-if="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-plus-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
              />
            </svg>
          </h3>

          <h3
            class="ml-2 mr-2 font-weight-bold text-primary"
            style="margin-top: 2px"
          >
            Extra
          </h3>
        </div>
        <p>
          Futebol americano, tênis, hockey, lutas, jogos de futebol com delay
        </p>
      </div>

      <HomeVencimento
        ref="homeVencimento"
        :planoAtivo="planoAtivo"
        :planoDias="planoDias"
        :planosAgendados="planosAgendados"
        :vencimento="vencimento"
        @recarregar="recarregarMeusDados()"
      />

      <div
        class="row"
        v-if="
          false && retornaUsuarioSite() == 'Weddbets' && propSite !== 'Extra'
        "
      >
        <div class="col col-md-12 d-flex justify-content-center">
          <span class="text-center" v-if="$siteAdmin == false">
            <a
              clsas="d-flex justify-content-center"
              href="https://t.me/Wedd_Bll"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-telegram"
                style="font-size: 36px; color: #0088cc"
              ></i>
              <h5 class="text-secondary" style="min-width: 135px">
                weddbets
              </h5></a
            ></span
          ><span class="text-center" style="margin-left: 10px" v-if="false">
            <a
              clsas="d-flex justify-content-center"
              href="https://wa.me/+5561986310597?text=Ol%C3%A1!%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20WeddBets"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-whatsapp"
                style="font-size: 36px; color: #34af23"
              ></i>
              <h5 style="color: black; min-width: 135px">
                <small>61 98631-0597</small>
              </h5></a
            ></span
          >
        </div>
      </div>

      <div class="row" style="margin-bottom: 50px; display: none">
        <div class="col-md-12 text-center">Mensagem</div>
      </div>

      <div class="row" style="zoom: 1; margin-bottom: 20px">
        <div class="col-md-12 text-center">
          <span>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              style="zoom: 1; margin-top: 10px"
              @click="carregarItens()"
            >
              Atualizar
            </button>
          </span>
        </div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12 col-md-8 text-center">
          <div class="text-center">
            <h2 class="tituloJogos">Ao Vivo</h2>
            <h6 style="display: none">Jogos com transmissão</h6>
          </div>
          <ListEventosHome
            ref="listEventosHomeLive"
            :itens="itens"
            :filtroSituacao="[3]"
            :icone="true"
            :itensFavoritos="itensFavoritos"
            @carregarItens="carregarItens()"
          />
          <div class="text-center">
            <h2 class="tituloJogos">Previstos</h2>
            <h6 style="display: none">
              Transmissão não confirmada, aguardando fonte
            </h6>
          </div>
          <ListEventosHome
            ref="listEventosHome"
            :itens="itens"
            :filtroSituacao="[1]"
            :icone="true"
            :itensFavoritos="itensFavoritos"
            @carregarItens="carregarItens()"
          />
          <div v-if="isAdmin">
            <div class="text-center">
              <h2 class="tituloJogos" v-if="retornaSite() == 'Weddbets'">
                Fontes
              </h2>
              <h2 class="tituloJogos" v-if="retornaSite() == '7live'">
                Invisivel
              </h2>
            </div>
            <ListEventosHome
              ref="listEventosHomeFontes"
              :itens="itens"
              :filtroSituacao="[2]"
              :icone="true"
              :itensFavoritos="itensFavoritos"
              @carregarItens="carregarItens()"
            />
          </div>
          <div class="text-center">
            <h2 class="tituloJogos">Encerrados</h2>
            <h6 style="display: none">
              Transmissão não confirmada, aguardando fonte
            </h6>
          </div>
          <ListEventosHome
            ref="listEventosHomeEncerrados"
            :itens="itens"
            :filtroSituacao="[4]"
            :icone="true"
            :itensFavoritos="itensFavoritos"
            @carregarItens="carregarItens()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import ListEventosHome from "../lists/ListEventosHomeAgrupado";
import HomeVencimento from "../features/HomeVencimento";

export default {
  name: "Home",
  components: { ListEventosHome, HomeVencimento },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    retornaUsuarioSite() {
      return this.$sessao ? this.$sessao.usuario.site : "";
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    async carregarItens() {
      var thisCall = this;

      var filtros = "?_limit=600";

      //* Verifica se foi especificado o site
      if (this.propSite !== "") {
        filtros = filtros + "&site=" + this.propSite;
      }

      let itensFavoritosTemp = {};

      //* Carrega os favoritos
      let responseFavorito;

      if (this.propFavorito == true) {
        responseFavorito = await api.get("/favorito");

        //* Verifica se carregou
        if (responseFavorito.data.erro == false) {
          //* Percorre os itens
          for (
            let indiceFavorito = 0;
            indiceFavorito < responseFavorito.data.itens.length;
            indiceFavorito++
          ) {
            itensFavoritosTemp[
              responseFavorito.data.itens[indiceFavorito].evento
            ] = responseFavorito.data.itens[indiceFavorito];
          }
        }

        //* Atualiza os novos itens
        this.itensFavoritos = itensFavoritosTemp;
      } else {
        api.get("/favorito").then((result) => {
          let itensFavoritosTemp2 = {};

          //* Verifica se carregou
          if (result.data.erro == false) {
            //* Percorre os itens
            for (
              let indiceFavorito = 0;
              indiceFavorito < result.data.itens.length;
              indiceFavorito++
            ) {
              itensFavoritosTemp2[result.data.itens[indiceFavorito].evento] =
                result.data.itens[indiceFavorito];
            }
          }

          thisCall.itensFavoritos = itensFavoritosTemp2;
        });
      }

      var routeEvento = "/evento";

      if (
        this.$sessao &&
        this.$sessao.usuario &&
        Object.keys(this.$sessao.usuario).includes("tipoUsuario") &&
        this.$sessao.usuario.tipoUsuario == "Assinante"
      ) {
        routeEvento = "/evento/cache";
      }

      const response = await api.get(routeEvento + filtros);
      api.valid(response.data, this.$router);

      if (
        this.$sessao &&
        this.$sessao.usuario &&
        Object.keys(this.$sessao.usuario).includes("gmt")
      ) {
        this.$refs.listEventosHomeLive.gmt = this.$sessao.usuario.gmt;
        this.$refs.listEventosHome.gmt = this.$sessao.usuario.gmt;

        if (Object.keys(this.$refs).includes("listEventosHomeFontes")) {
          this.$refs.listEventosHomeFontes.gmt = this.$sessao.usuario.gmt;
        }

        this.$refs.listEventosHomeEncerrados.gmt = this.$sessao.usuario.gmt;
      }

      var arrEventos = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        //* Define o pais padrao
        item.competicaoPais = "";

        //* Define o pais pela competicao
        if (item.competicao && item.competicao !== "") {
          let arrCompeticao = item.competicao.split(",");

          if (arrCompeticao.length > 0) {
            item.competicaoPais = util
              .countryNameToCode(arrCompeticao[0])
              .toLowerCase();
          }
        }

        item.competicaoPaisUrl =
          item.competicaoPais == ""
            ? "/assets/worldflag3.png"
            : "https://flagcdn.com/h20/" + item.competicaoPais + ".png";

        if (
          this.propFavorito == false ||
          (this.propFavorito == true && itensFavoritosTemp[item._id])
        ) {
          //* Verifica se deve filtrar o site
          if (this.propSite !== "") {
            if (item.site == this.propSite) {
              arrEventos.push(item);
            }
          } else {
            if (item.site !== "Extra") {
              arrEventos.push(item);
            }
          }
        }
      }

      this.itens = arrEventos;
    },
    async recarregarMeusDados() {
      const response = await api.get("/usuario/meus-dados");

      this.planoAtivo = response.data.item.planoAtivo;
      this.planoDias = response.data.item.planoDias;

      if (response.data.item.planosAgendados) {
        this.planosAgendados = response.data.item.planosAgendados;
      }

      if (response.data.item.planos.length > 0) {
        if (response.data.item.plano) {
          this.vencimento = util.formatDate(response.data.item.plano.dataFim);
        } else {
          this.vencimento = "";
        }
      } else {
        this.vencimento = util.formatDate(response.data.item.vencimento);
      }
    },
  },
  data: function () {
    return {
      planoAtivo: true,
      planoDias: 10,
      vencimento: "",
      planosAgendados: new Array(),
      isAdmin: false,
      itens: [],
      itensFavoritos: {},
    };
  },
  props: {
    propSite: { type: String, default: "" },
    propFavorito: { type: Boolean, default: false },
  },
  async mounted() {
    var componentThis = this;

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";

    componentThis.recarregarMeusDados();
    componentThis.carregarItens();

    setInterval(function () {
      componentThis.carregarItens();
    }, 20000);
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}
</style>